if (!customElements.get('gifting-video-hero')) {
  customElements.define('gifting-video-hero', class extends HTMLElement {
    connectedCallback() {
      this.video = this.querySelector('video');
      this.button = this.querySelector('.gf-film__toggle');
      if (!this.video || !this.button) return;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.update = () => {
        const action = this.video.paused ? 'Play' : 'Pause';
        this.button.dataset.paused = String(this.video.paused);
        this.button.setAttribute('aria-label', `${action} background video`);
      };
      this.play = () => this.video.play().catch(this.update);
      this.toggle = () => this.video.paused ? this.play() : this.video.pause();
      this.onMotion = () => { if (this.motion.matches) this.video.pause(); };
      this.button.addEventListener('click', this.toggle);
      this.video.addEventListener('play', this.update);
      this.video.addEventListener('pause', this.update);
      this.motion.addEventListener('change', this.onMotion);
      this.button.hidden = false;
      this.video.muted = true;
      this.update();
      if (!this.motion.matches) this.play();
    }

    disconnectedCallback() {
      if (!this.video || !this.button) return;
      this.video.pause();
      this.button.removeEventListener('click', this.toggle);
      this.video.removeEventListener('play', this.update);
      this.video.removeEventListener('pause', this.update);
      this.motion.removeEventListener('change', this.onMotion);
    }
  });
}
